import "core-js/modules/es.array.push.js";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bf87e8d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  title: "Media Player"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "the-shell-header-buttons"
}, null, -1));
const _hoisted_3 = {
  title: "Back"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "the-shell-header"
}, null, -1));
import { IonToolbar } from '@ionic/vue';
import { computed, ref, watch, nextTick, onMounted, onUnmounted } from 'vue';
import Router from '@/router';
import AppIconWaveform from '@/components/AppIconWaveform.vue';
import TheShellHeaderCallIndicator from '@/components/TheShellHeaderCallIndicator.vue';
import TheShellHeaderMediaPlayer from '@/components/TheShellHeaderMediaPlayer.vue';
import useChats from '@/composables/global/use-chats';
import useGlobalMediaPlayer from '@/composables/global/use-global-audio-player';
import useInitLoader from '@/composables/global/use-init-loader';
import useResponsiveness from '@/composables/global/use-responsiveness';
import useShellHeader from '@/composables/global/use-shell-header';
import { getComputedStyleValue } from '@/utils/style';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellHeader',
  setup(__props) {
    _useCssVars(_ctx => ({
      "bf766a0c": _unref(textColor)
    }));
    const {
      callInProgress
    } = useChats();
    const {
      appDataInitialized
    } = useInitLoader();
    const {
      audioIsInitialized,
      isPlaying,
      popoverOpen,
      popoverEvent,
      openPopover,
      closePopover
    } = useGlobalMediaPlayer();
    const {
      mdDown
    } = useResponsiveness();
    const {
      appTitle,
      backgroundColor,
      isBackToRootRoute,
      menuButtonBack,
      textColor
    } = useShellHeader();
    const isLoading = ref(true);
    const headerRef = ref();
    const observer = ref();
    const navBack = () => {
      if (isBackToRootRoute.value) {
        const rootRoute = Router.currentRoute.value.path.split('/')[1];
        Router.push(`/${rootRoute}`);
      } else {
        const prevRoute = Router.currentRoute.value.path.split('/').slice(0, -1).join('/');
        Router.push(prevRoute);
      }
    };
    function updateToolbarHeight() {
      const toolbar = headerRef.value;
      if (toolbar) {
        const height = toolbar.$el.offsetHeight - getComputedStyleValue(document.documentElement, '--safe-area-top');
        document.documentElement.style.setProperty('--header-toolbar-height', `${height}px`);
      }
    }
    //only visible on small devices
    const showCallInProgressIndicator = computed(() => mdDown.value && callInProgress.value);
    onMounted(async () => {
      if (headerRef.value) {
        observer.value = new MutationObserver(() => {
          nextTick(updateToolbarHeight);
        });
        observer.value.observe(headerRef.value.$el, {
          childList: true,
          subtree: true,
          attributes: true // Detect style changes (like v-show)
        });
      }
      updateToolbarHeight();
      await appDataInitialized();
      isLoading.value = false;
    });
    onUnmounted(() => {
      if (observer.value) {
        observer.value.disconnect();
        observer.value = undefined;
      }
    });
    watch(appTitle, () => {
      nextTick(updateToolbarHeight);
    });
    return (_ctx, _cache) => {
      const _component_ion_menu_button = _resolveComponent("ion-menu-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_text = _resolveComponent("ion-text");
      const _component_ion_title = _resolveComponent("ion-title");
      const _component_ion_header = _resolveComponent("ion-header");
      return _openBlock(), _createBlock(_component_ion_header, {
        ref_key: "headerRef",
        ref: headerRef
      }, {
        default: _withCtx(() => [_createVNode(_unref(IonToolbar), {
          style: _normalizeStyle(_unref(backgroundColor) ? `--background: ${_unref(backgroundColor)}` : '')
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_ion_buttons, {
            slot: "start"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_menu_button, {
              color: "toolbar-text",
              disabled: isLoading.value
            }, null, 8, ["disabled"]), showCallInProgressIndicator.value ? (_openBlock(), _createBlock(TheShellHeaderCallIndicator, {
              key: 0
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 512), [[_vShow, !_unref(menuButtonBack)]]), _withDirectives(_createVNode(_component_ion_buttons, {
            slot: "primary"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_button, {
              id: "media-player-button",
              onClick: _cache[0] || (_cache[0] = $event => _unref(openPopover)($event))
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_unref(isPlaying) ? (_openBlock(), _createBlock(AppIconWaveform, {
                key: 0
              })) : (_openBlock(), _createBlock(_component_ion_icon, {
                key: 1,
                name: "play-circle-outline",
                slot: "icon-only"
              }))])]),
              _: 1
            }), _createVNode(TheShellHeaderMediaPlayer, {
              isOpen: _unref(popoverOpen),
              event: _unref(popoverEvent),
              onDidDismiss: _unref(closePopover)
            }, null, 8, ["isOpen", "event", "onDidDismiss"])]),
            _: 1
          }, 512), [[_vShow, _unref(audioIsInitialized)]]), _createVNode(_component_ion_buttons, {
            slot: "end"
          }, {
            default: _withCtx(() => [_hoisted_2, _withDirectives(_createVNode(_component_ion_button, {
              style: _normalizeStyle(_unref(textColor) ? `--color: ${_unref(textColor)}` : ''),
              onClick: navBack
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_ion_icon, {
                slot: "icon-only",
                icon: "close"
              })])]),
              _: 1
            }, 8, ["style"]), [[_vShow, _unref(menuButtonBack)]])]),
            _: 1
          }), _createVNode(_component_ion_title, {
            style: _normalizeStyle(_unref(textColor) ? `color: ${_unref(textColor)}` : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_text, {
              class: "title-font",
              "text-wrap": ""
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(appTitle)), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["style"])]),
          _: 1
        }, 8, ["style"]), _hoisted_4]),
        _: 1
      }, 512);
    };
  }
});